<sabis-ngx-dialog [scTitle]="title">

  <div modal-body>

    @if (isLoading) {
      <div>Loading...Please Wait</div>
    } @else {
      <sca-card-view cardTitle="Feedback Request">
        <form #f="ngForm" novalidate>
          <div class="sc-form">
            <div class="sc-form-row">
              <div class="sc-form-control">
                <sabis-ngx-input scType="text" [(ngModel)]="userEmail"
                  [required]="true"
                  (ngModelChange)="onRefereeChanged()"
                  scLabel="Email Address"
                  name="RefereeEmail">
                </sabis-ngx-input>
              </div>
            </div>
            <div class="sc-form-row">
              <div class="sc-form-control">
                <!-- Feedback form Templates-->
                @if (feedbackForms.length > 1) {
                  <sabis-combobox2
                    [(ngModel)]="selectedFeedbackFormId"
                    class="sabis-combobox2"
                    [scItems]="feedbackForms"
                    scLabel="Feedback Form"
                    scValueField="itemId"
                    [required]="true"
                    name="feedbackFormTemplates"
                    scDisplayField="name">
                  </sabis-combobox2>
                }
              </div>
            </div>
          </div>
        </form>
      </sca-card-view>
    }

    <!-- email editor -->
    @if (!isLoading) {
      <div>
        <sca-email [email]="email" #emailForm
          [noTemplate]="false"
          [filterEmailTemplates]="true"
          [allowedEmailTemplateIds]="allowedEmailTemplateIds"
          [canAttachDocuments]="canAttachDocuments"
          [showRecipient]="false"
        [showEmailCC]="showEmailCC"></sca-email>
      </div>
    }
  </div>

  <div modal-footer>

    @if (!isDisabled) {
      <!-- send -->
      <sabis-ngx-button (click)="onSaveClick()">
        Send
      </sabis-ngx-button>
      <!-- cancel -->
      <sabis-ngx-button scColor="warning" (click)="onCancelClick()">
        Cancel
      </sabis-ngx-button>
    }
  </div>

</sabis-ngx-dialog>
